import { OrderDetailComponent } from "./../dialogs/order-detail/order-detail.component";
import { CommentBoxComponent } from "./../dialogs/comment-box/comment-box.component";
import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationDialogComponent } from "../dialogs/confirmation-dialog/confirmation-dialog.component";
import { MountUsbConfirmComponent } from "../dialogs/mount-usb-confirm/mount-usb-confirm.component";
import { PromptDialogComponent } from "../dialogs/prompt-dialog/prompt-dialog.component";
import { DropdownDialogComponent } from "../../AdminPanel/op product Builder/banners and offers/dropdown-dialog/dropdown-dialog.component";
import { VidioDialogComponent } from "../dialogs/vidio-dialog/vidio-dialog.component";
import { ImageDialogComponent } from "../dialogs/image-dialog/image-dialog.component";
import { LightBoxDialogComponent } from "../dialogs/light-box-dialog/light-box-dialog.component";
import { TemplateFieldDialogComponent } from "../../AdminPanel/op product Builder/Templates/template-field-dialog/template-field-dialog.component";
import { OpNewsletterDialogComponent } from "../../AdminPanel/op-news-letters/op-newsletter-dialog/op-newsletter-dialog.component";
import { OfferBoxComponent } from "../dialogs/offer-box/offer-box.component";
import { FullScreenProofcardComponent } from "../dialogs/full-screen-proofcard/full-screen-proofcard.component";
import { OpChildDialogComponent } from "../../AdminPanel/Orders/op-child-dialog/op-child-dialog.component";
import { LinkProofcardDialogComponent } from "../dialogs/link-proofcard-dialog/link-proofcard-dialog.component";
import { OrderEditDialogComponent } from "../dialogs/order-edit-dialog/order-edit-dialog.component";
import { Order } from "../models/order_model";
import { TermsConditionsComponent } from "../dialogs/terms-conditions/terms-conditions.component";
import { OpContinueShoppingPopUpComponent } from "../dialogs/op-continue-shopping-pop-up/op-continue-shopping-pop-up.component";
import { LoginOrRegisterDialogComponent } from "../dialogs/login-or-register-dialog/login-or-register-dialog.component";
import { BrowserSupportComponent } from "../dialogs/browser-support/browser-support.component";
import { CheckoutOptionsComponent } from "../../WebPanel/checkout-options/checkout-options.component";
import { StudentNameUpdateComponent } from "../dialogs/student-name-update/student-name-update.component";
import { OrderEditAddressComponent } from "../dialogs/order-edit-address/order-edit-address.component";
import { OrderEditShippingAddressComponent } from "../dialogs/order-edit-shipping-address/order-edit-shipping-address.component";
import { CustomerMessageShowComponent } from "../dialogs/customer-message-show/customer-message-show.component";
import { DescriptionBoxComponent } from "../dialogs/description-box/description-box.component";
import { ProofcardImageViewerComponent } from "../dialogs/proofcard-image-viewer/proofcard-image-viewer.component";
import { PosterCredentialManagerComponent } from "../dialogs/poster-credential-manager/poster-credential-manager.component";
import { ExportFieldDialogComponent } from "../../AdminPanel/op product Builder/product export/export-field-dialog/export-field-dialog/export-field-dialog.component";
import { CalendarBookingDetailDialogComponent } from "../../AdminPanel/op-booking-calender/calendar-booking-detail-dialog/calendar-booking-detail-dialog.component";
import { ProofcardDownloadPoupComponent } from "../../AdminPanel/sites/jobs/proofcard/op-poofcard/proofcard-download-poup/proofcard-download-poup.component";
import { OrderdeadlinedialogComponent } from "../../AdminPanel/sites/jobs/proofcard/proofcard-uploader/orderdeadlinedialog/orderdeadlinedialog/orderdeadlinedialog.component";
import { OpVerifyDownloadComponent } from "../../WebPanel/op-verify-download/op-verify-download.component";
import { AllDeleteDialogComponent } from "../dialogs/all-delete-dialog/all-delete-dialog.component";
import { FtpBulkUploadComponent } from "../dialogs/ftp-bulk-upload/ftp-bulk-upload.component";
import { OrderDetailDownloadComponent } from "../dialogs/order-detail-download/order-detail-download.component";
import { OrderImageViewerComponent } from "../dialogs/order-image-viewer/order-image-viewer.component";
import { UploadCompleteDialogueComponent } from "../../AdminPanel/sites/jobs/proofcard/proofcard-uploader/upload-complete-dialogue/upload-complete-dialogue.component";

@Injectable()
export class ConfirmationDialogService {
  then(arg0: (isConfirmed: any) => void) {
    throw new Error("Method not implemented.");
  }
  private dialogShown = false;
  constructor(private modalService: NgbModal) {}

  public confirm(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm",
    needDoubleConfirm: boolean = false,
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.needDoubleConfirm = needDoubleConfirm;


    return modalRef.result;
  }
  confirmDelete(
    title: string,
    message: string,
    btnOkText: string = 'OK',
    btnCancelText: string = 'Cancel',
    dialogSize: 'sm' | 'lg' = 'sm',
    checkboxLabel: string = 'checkboxLabel',
    checkboxState: boolean = false
  ): Promise<boolean> {
    const modalRef = this.modalService.open(AllDeleteDialogComponent, {
      size: dialogSize,
      backdrop: 'static',
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.checkboxLabel = checkboxLabel;
    modalRef.componentInstance.checkboxState = checkboxState;

    return modalRef.result;
  }
  public closeConfirm() {
    this.modalService.dismissAll();
  }

  public ftpBulkUpload(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnViewLogText: string = "Click To View Log",
    dialogSize: "sm" | "lg" = "sm",
  ): Promise<boolean> {
    const modalRef = this.modalService.open(FtpBulkUploadComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnViewLogText = btnViewLogText;

    return modalRef.result;
  }

  public mount_usb_confirm(
    title: string,
    message: string,
    btnOkText: string = "Yes",
    btnCancelText: string = "No",
    dialogSize: "sm" | "lg" = "sm",
    needDoubleConfirm: boolean = false,
  ): Promise<boolean> {
    const modalRef = this.modalService.open(MountUsbConfirmComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.needDoubleConfirm = needDoubleConfirm;
    return modalRef.result;
  }

  public prompt(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(PromptDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public dropdown(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(DropdownDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    return modalRef.result;
  }

  public video(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "lg" = "lg",
    productId: string,
    storeType: string
  ): Promise<boolean> {
    const modalRef = this.modalService.open(VidioDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.productId = productId;
    modalRef.componentInstance.storeType = storeType;
    return modalRef.result;
  }

  public ContineShopping(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "sm" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OpContinueShoppingPopUpComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public checkoutOptions(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "sm" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(CheckoutOptionsComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public image(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "lg" = "lg",
    productId: string,
    storeType: string
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ImageDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.productId = productId;
    modalRef.componentInstance.storeType = storeType;
    return modalRef.result;
  }
  public OrderChildImage(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OpChildDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public proofcard(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(FullScreenProofcardComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public lightBox(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "lg" = "lg",
    productId: string,
    storeType: string
  ): Promise<boolean> {
    const modalRef = this.modalService.open(LightBoxDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.productId = productId;
    modalRef.componentInstance.storeType = storeType;
    return modalRef.result;
  }

  public templateFieldDialog(
    templateName: any,
    templateData: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(TemplateFieldDialogComponent, {
      backdrop: "static",
      size: dialogSize,
    });
    modalRef.componentInstance.templateName = templateName;
    modalRef.componentInstance.templateData = templateData;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    return modalRef.result;
  }

  public orderEditDialog(
    title: string,
    message: any,
    btnOkText: string = "Update",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OrderEditDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public newsLetterdialogBox(
    title: any,
    message: any,
    newsletterId: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OpNewsletterDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.newsletterId = newsletterId;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    return modalRef.result;
  }

  public GDPRRemoveDialogBox(
    title: any,
    message: any,
    newsletterId: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OpNewsletterDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.newsletterId = newsletterId;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    return modalRef.result;
  }

  public OfferBox(
    title: string,
    message: any,
    btnOkText: string = "Close",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OfferBoxComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.productDetail = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public descriptionBox(
    title: string,
    message: any,
    btnOkText: string = "Close",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(DescriptionBoxComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public linkProofcard(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(LinkProofcardDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public termsNCondition(
    title: string,
    message: string,
    btnOkText: string = "Accept",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(TermsConditionsComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public loginOrRegister(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(LoginOrRegisterDialogComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public commentBox(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<any> {
    const modalRef = this.modalService.open(CommentBoxComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public orderDetail(
    title: string,
    message: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OrderDetailComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public orderDetailDownload(
    title: string,
    message: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OrderDetailDownloadComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }


  public browserSupport(
    title: string,
    message: any,
    // btnOkText: string = "OK",
    // btnCancelText: string = "Cancel",
    dialogSize: "lg" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(BrowserSupportComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    // modalRef.componentInstance.btnOkText = btnOkText;
    // modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public updateStudentName(
    title: any,
    message: any,
    ProofcardData: any,
    btnOkText: string = "Update",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(StudentNameUpdateComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.ProofcardData = ProofcardData;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    return modalRef.result;
  }

  public calendarBookingDetail(
    title: string,
    message: any,
    bookingDetail: any,
    btnOkText: string = "Update",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(
      CalendarBookingDetailDialogComponent,
      {
        size: dialogSize,
        backdrop: "static",
      }
    );
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.bookingDetail = bookingDetail;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public orderEditAddress(
    title: string,
    message: any,
    addressData: any,
    btnOkText: string = "Update",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OrderEditAddressComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.addressData = addressData;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public proofcardDownload(
    title: string,
    message: any,
    addressData: any,
    btnOkText: string = "Update",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "sm" = "lg"
  ): Promise<boolean> {
    console.log("addressData", addressData);
    const modalRef = this.modalService.open(ProofcardDownloadPoupComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.addressData = addressData;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public orderEditShippingAddress(
    title: string,
    message: any,
    shippingAddressData: any,
    btnOkText: string = "Update",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OrderEditShippingAddressComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.shippingAddressData = shippingAddressData;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public CustomerMessageShow(
    title: string,
    message: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(CustomerMessageShowComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  private actionCallback: (event: any) => void;

  setActionCallback(callback: (event: any) => void) {
    this.actionCallback = callback;
  }

  public proofcardImageViewer(
    title: string,
    message: string,
    images: any[],
    selectedImages: any[],
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "sm" = "lg",
    currentId: string,
    isShowClickToSelect: boolean = false
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ProofcardImageViewerComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    setTimeout(() => {
      const modalDialog = document.querySelector('.modal-dialog') as HTMLElement;
      if (modalDialog) {
          modalDialog.style.maxWidth = '1250px';
          modalDialog.classList.add('proofcard-custom-modal-size');
      }
    }, 0);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.images = images;
    modalRef.componentInstance.selectedImages = selectedImages;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.currentId = currentId;
    modalRef.componentInstance.isShowClickToSelect = isShowClickToSelect;

    // click to select functionality
    modalRef.componentInstance.clickToSelectEvent.subscribe((event: any) => {
      if (this.actionCallback) {
        this.actionCallback(event);
      }
    });

    return modalRef.result;
  }

  public sendPosterCredentialMailToManager(
    title: string,
    message: string,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "sm" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(PosterCredentialManagerComponent, {
      size: dialogSize,
      backdrop: "static",
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public exportProductDialog(
    name: any,
    exportData: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "lg"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ExportFieldDialogComponent, {
      backdrop: "static",
      size: dialogSize,
    });
    modalRef.componentInstance.name = name;
    modalRef.componentInstance.exportData = exportData;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    return modalRef.result;
  }

  public orderDeadlineDialog(
    name: any,
    exportData: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OrderdeadlinedialogComponent, {
      backdrop: "static",
      size: dialogSize,
    });

    modalRef.componentInstance.name = name;
    modalRef.componentInstance.exportData = exportData;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public uploadCompleteDialogue(
    name: any,
    message: any,
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "sm" | "lg" = "sm"
  ): Promise<boolean> {
    const modalRef = this.modalService.open(UploadCompleteDialogueComponent, {
      backdrop: "static",
      size: dialogSize,
    });

    modalRef.componentInstance.name = name;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

  public orderImageViewer(
    title: string,
    message: string,
    images: any[],
    btnOkText: string = "OK",
    btnCancelText: string = "Cancel",
    dialogSize: "lg" | "sm" = "lg",
    currentId: string
  ): Promise<boolean> {
    const modalRef = this.modalService.open(OrderImageViewerComponent, {
      size: dialogSize,
      backdrop: "static",
      centered: true
    });
    // setTimeout(() => {
    //   const modalDialog = document.querySelector('.modal-dialog') as HTMLElement;
    //   if (modalDialog) {
    //       modalDialog.style.maxWidth = '1250px';
    //       modalDialog.classList.add('proofcard-custom-modal-size');
    //   }
    // }, 0);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.images = images;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.currentId = currentId;

    return modalRef.result;
  }

  // public otpVerify(
  //   title: string,
  //   message: any,
  //   bookingDetail: any,
  //   btnOkText: string = "Update",
  //   btnCancelText: string = "Cancel",
  //   dialogSize: "sm" | "lg" = "sm"
  // ): Promise<boolean> {
  //   const modalRef = this.modalService.open(
  //     OpVerifyDownloadComponent,
  //     {
  //       size: dialogSize,
  //       backdrop: "static",
  //     }
  //   );
  //   modalRef.componentInstance.title = title;
  //   modalRef.componentInstance.message = message;
  //   modalRef.componentInstance.bookingDetail = bookingDetail;
  //   modalRef.componentInstance.btnOkText = btnOkText;
  //   modalRef.componentInstance.btnCancelText = btnCancelText;

  //   return modalRef.result;
  // }
}
